import React from 'react';
import { Title, NoMatchText, NoResultsWrapper } from './NoSearchResults.styles';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { MacroButton } from '../../../../DecisionTree.styles';
import { useDispatch } from 'react-redux';

const NoSearchResults = ({ isSearchBothOrdersAndSubscriptions, isShowMacroButton }) => {
  const dispatch = useDispatch();

  return (
    <NoResultsWrapper key={'noSubscriptionsFound'}>
      {isSearchBothOrdersAndSubscriptions ? (
        <Title>No subscriptions or orders found</Title>
      ) : (
        <Title>No subscriptions found</Title>
      )}
      {isShowMacroButton && (
        <MacroButton active={true} onClick={() => dispatch(addEdgeToDecisionTreePath('subscription_not_found'))}>
          GET MACRO
        </MacroButton>
      )}
      <NoMatchText>
        Please ask the customer for the email and phone number <br />
        they used to create the subscription and try searching again.
      </NoMatchText>
    </NoResultsWrapper>
  );
};

export default NoSearchResults;
